// src/store/uiSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isMobileMenuOpen: false,
  isCartOpen: false,
  isLoginOpen: false,
  // 🔑 РЕЖИМ МОДАЛКИ ВХОДА (2026-10-29): 'login' | 'register'.
  //    Раньше модалка открывалась только «на вход», а регистрация была
  //    отдельной страницей — и человек с витрины стикеров уходил с неё.
  //    Одна модалка с двумя вкладками решает обе задачи без перехода.
  loginMode: 'login',
  // Что сделать ПОСЛЕ успешного входа: { action: 'upload' | 'board' | null }.
  // Хранится здесь, а не в компоненте, потому что модалка живёт в Layout:
  // страница стикеров ставит намерение, модалка закрывается и его читает.
  postLoginIntent: null,
  isFavoritesOpen: false,
  toast: {
    open: false,
    message: '',
    type: 'info', // 'info' | 'success' | 'error' | 'warning'
  },
  modal: {
    open: false,
    type: null,
    data: null,
  },
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    toggleMobileMenu: (state) => {
      state.isMobileMenuOpen = !state.isMobileMenuOpen;
    },
    setMobileMenu: (state, action) => {
      state.isMobileMenuOpen = action.payload;
    },
    toggleCart: (state) => {
      state.isCartOpen = !state.isCartOpen;
    },
    setCart: (state, action) => {
      state.isCartOpen = action.payload;
    },
    toggleLogin: (state) => {
      state.isLoginOpen = !state.isLoginOpen;
    },
    setLogin: (state, action) => {
      state.isLoginOpen = action.payload;
    },
    // Открыть модалку в нужной вкладке, помня, зачем её открыли.
    openAuth: (state, action) => {
      state.isLoginOpen = true;
      state.loginMode = action.payload?.mode || 'login';
      state.postLoginIntent = action.payload?.intent || null;
    },
    closeAuth: (state) => {
      state.isLoginOpen = false;
      state.postLoginIntent = null;
    },
    setLoginMode: (state, action) => {
      state.loginMode = action.payload;
    },
    consumePostLoginIntent: (state) => {
      state.postLoginIntent = null;
    },
    toggleFavorites: (state) => {
      state.isFavoritesOpen = !state.isFavoritesOpen;
    },
    setFavorites: (state, action) => {
      state.isFavoritesOpen = action.payload;
    },
    showToast: (state, action) => {
      state.toast = {
        open: true,
        message: action.payload.message,
        type: action.payload.type || 'info',
      };
    },
    hideToast: (state) => {
      state.toast.open = false;
    },
    showModal: (state, action) => {
      state.modal = {
        open: true,
        type: action.payload.type,
        data: action.payload.data || null,
      };
    },
    hideModal: (state) => {
      state.modal.open = false;
      state.modal.type = null;
      state.modal.data = null;
    },
  },
});

export const {
  toggleMobileMenu,
  setMobileMenu,
  toggleCart,
  setCart,
  toggleLogin,
  setLogin,
  openAuth,
  closeAuth,
  setLoginMode,
  consumePostLoginIntent,
  toggleFavorites,
  setFavorites,
  showToast,
  hideToast,
  showModal,
  hideModal,
} = uiSlice.actions;

export default uiSlice.reducer;